import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const limitSkuPageRBAC = {
  pageID: '38ed30604221c8e5ca6d6821a3a1c741',
  elementID: {
    TableList: '151e1f54dd364330fae7f58dce6ab013',
    BtnCreate: 'fe5d902365364366f16cc15b2c6842d3',
    BtnUpdate: '5a3a69ca20364366f16c98bc91153280',
  },
} as const

export const useRBACLimitSkuPage = createUseRBAC(limitSkuPageRBAC.elementID)

export type UseRBACLimitSkuPageType = ReturnType<typeof useRBACLimitSkuPage>
